import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { Slider } from 'antd';

const ControlledSliderField = ({ name, min, max, label, marks }) => {
  // eslint-disable-next-line
  const [field, meta, helpers] = useField(name);

  const sliderMarksProps = {
    [min]: {
      style: {},
      label: <strong>{min} {label}</strong>,
    },
    [max]: {
      style: {},
      label: <strong>{max} {label}</strong>,
    },
    ...marks,
  };

  return (
    <Slider
      min={min}
      max={max}
      marks={sliderMarksProps}
      value={meta.value}
      tooltipVisible
      tooltipPlacement="bottom"
      onChange={(val) => helpers.setValue(val)}
      onAfterChange={(val) => helpers.setValue(val)}
    />
  );
};

ControlledSliderField.defaultProps = {
  min: 0,
  max: 95,
  label: "",
  marks: {},
};

const { string, number, shape } = PropTypes;

ControlledSliderField.propTypes = {
  name: string.isRequired,
  min: number,
  max: number,
  label: string,
  marks: shape({}),
};

export default ControlledSliderField;
